/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ex_TitleInputs */

const en_to_xml_ex_title = /** @type {(inputs: To_Xml_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converting a nested record`)
};

const ko_to_xml_ex_title = /** @type {(inputs: To_Xml_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩 레코드 변환하기`)
};

const ja_to_xml_ex_title = /** @type {(inputs: To_Xml_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストしたレコードを変換する`)
};

/**
* | output |
* | --- |
* | "Converting a nested record" |
*
* @param {To_Xml_Ex_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ex_title = /** @type {((inputs?: To_Xml_Ex_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ex_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ex_title(inputs)
	if (locale === "ko") return ko_to_xml_ex_title(inputs)
	return ja_to_xml_ex_title(inputs)
});